import React, { useState, useEffect } from "react";
import { Switch, Icon, Tag, Typography } from "@ann/web-components";
import {
  CardContainer,
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
  CardContent,
  ChevronWrapper,
  CardHeaderContent,
  HeaderLeftColumn,
  HeaderRightColumn,
  SwitchIconLabelContainer,
  TitleDescriptionContainer,
  SwitchTitleRow,
  IconWrapper,
} from "./ExpandablePermissionCard.styled";

const ExpandablePermissionCard = ({
  title,
  subtitle,
  icon = "person",
  showIcon = true,
  showSwitch = true,
  onChange,
  label,
  tagValue,
  buttonMenu,
  children,
  defaultExpanded = false,
  isExpanded: controlledExpanded,
  onToggle,
  noBorder = false,
}) => {
  const isControlled = controlledExpanded !== undefined;
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  
  // Sync internal state with controlled prop
  useEffect(() => {
    if (isControlled) {
      setInternalExpanded(controlledExpanded);
    }
  }, [isControlled, controlledExpanded]);

  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleToggle = () => {
    if (isControlled && onToggle) {
      onToggle();
    } else {
      setInternalExpanded((prev) => !prev);
    }
  };

  return (
    <CardContainer $noBorder={noBorder}>
      <CardHeader onClick={handleToggle} $isExpanded={isExpanded}>
        <CardHeaderLeft>
          <CardHeaderContent>
            <HeaderLeftColumn>
              {label ? (
                <SwitchIconLabelContainer>
                  {showSwitch && (
                    <Switch onChange={onChange || (() => {})} size="small" />
                  )}
                  {showIcon && (
                    <IconWrapper>
                      <Icon name={icon} size="small" color="primary-alt" />
                    </IconWrapper>
                  )}
                  <Typography category="body" size="medium" weight="regular">
                    {label}
                  </Typography>
                </SwitchIconLabelContainer>
              ) : (
                <TitleDescriptionContainer>
                  <SwitchTitleRow>
                    {showSwitch && (
                      <Switch onChange={onChange || (() => {})} size="small" />
                    )}
                    {showIcon && (
                      <IconWrapper>
                        <Icon name={icon} size="small" color="primary-alt" />
                      </IconWrapper>
                    )}
                    <Typography category="body" size="medium" weight="bold">
                      {title}
                    </Typography>
                  </SwitchTitleRow>
                  {subtitle && (
                    <Typography category="body" size="small" weight="regular" color="body">
                      {subtitle}
                    </Typography>
                  )}
                </TitleDescriptionContainer>
              )}
            </HeaderLeftColumn>
            <HeaderRightColumn>
              {buttonMenu && buttonMenu}
              {tagValue && (
                <Tag
                  color="neutral"
                  onClose={() => {}}
                  size="medium"
                  text={tagValue}
                />
              )}
            </HeaderRightColumn>
          </CardHeaderContent>
        </CardHeaderLeft>
        <CardHeaderRight>  
          <ChevronWrapper $isExpanded={isExpanded}>
            <Icon name="chevronDown" size="medium" />
          </ChevronWrapper>
        </CardHeaderRight>
      </CardHeader>
      {children && (
        <CardContent $isExpanded={isExpanded}>
          {children}
        </CardContent>
      )}
    </CardContainer>
  );
};

export default ExpandablePermissionCard;

